import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://ugmsgrbawrdcehdgdjin.supabase.co';
const supabaseAnonKey =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVnbXNncmJhd3JkY2VoZGdkamluIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njc5OTk4NzMsImV4cCI6MjA4MzU3NTg3M30.-bo0-r7KpE_1h5qQofmsbHedk6osk_NZZ8sEWtMHF0s';

// Florida AI Marketing Experts company_id (from companies table)
const FAME_COMPANY_ID = '1520580a-cffc-4e09-bc12-626d0ddce98a';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export interface ContactSubmission {
  name: string;
  email: string;
  phone: string;
  business: string;
  message: string;
}

export async function submitContact(data: ContactSubmission) {
  const { data: result, error } = await supabase
    .from('leads')
    .insert([
      {
        company_id: FAME_COMPANY_ID,
        business_name: data.business,
        owner_name: data.name,
        phone_number: data.phone,
        email: data.email,
        niche: 'general_contact',
        location: '',
        source: 'fame_web_contact',
        status: 'new',
        needs_report: false,
        audit_data: {
          site: 'floridaaimarketingexperts.com',
          form: 'contact',
          message: data.message,
        },
      },
    ])
    .select()
    .single();
  if (error) throw error;
  return result;
}

export interface AuditSubmission {
  name: string;
  email: string;
  phone: string;
  company: string;
  website: string;
  industry: string;
  monthlyLeads: string;
  challenges: string;
}

export async function submitAuditRequest(data: AuditSubmission) {
  const { data: result, error } = await supabase
    .from('leads')
    .insert([
      {
        company_id: FAME_COMPANY_ID,
        business_name: data.company,
        owner_name: data.name,
        phone_number: data.phone,
        email: data.email,
        niche: data.industry || 'audit_request',
        location: '',
        source: 'fame_web_audit',
        status: 'new',
        needs_report: true,
        audit_data: {
          site: 'floridaaimarketingexperts.com',
          form: 'audit',
          website: data.website,
          industry: data.industry,
          monthly_leads: data.monthlyLeads,
          challenges: data.challenges,
        },
      },
    ])
    .select()
    .single();
  if (error) throw error;
  return result;
}
